import { render } from "./navigate-menu.vue?vue&type=template&id=052379f0"
import script from "./navigate-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./navigate-menu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/navigate-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "052379f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('052379f0', __exports__)) {
    api.reload('052379f0', __exports__)
  }
  
  module.hot.accept("./navigate-menu.vue?vue&type=template&id=052379f0", () => {
    api.rerender('052379f0', render)
  })

}


export default __exports__